import { render } from "./SimilarityComparison.vue?vue&type=template&id=8bc1f3bc&scoped=true"
import script from "./SimilarityComparison.vue?vue&type=script&lang=js"
export * from "./SimilarityComparison.vue?vue&type=script&lang=js"

import "./SimilarityComparison.vue?vue&type=style&index=0&id=8bc1f3bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc1f3bc"]])

export default __exports__